// [TODO-1703] - Merge with DNADocumentThumbnail - address in [BEAC-1781]
import React from 'react';
import { Pressable } from 'react-native';
import { Stack, DNABox, Iffy, Popover } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { DNAThumbnail, ThumbnailOverlayIcon } from 'src/components/DNA';
import { CustomDeckORM } from 'src/types/types';
import {
  DEFAULT_POPOVER_PROPS,
  HOVER_PREVIEW_SIZES,
  ThumbnailHoverProps,
  useHoverContentOffset,
} from './DNADocumentThumbnail';
import { useAppSettings } from 'src/state/context/AppSettings';

export interface DNACustomDeckProps {
  customDeckORM: CustomDeckORM,
  showProcessing?: boolean,
  unavailableContent?: boolean,
  width: number,
  height: number,
  onPress?: () => void,
}

export type ThumbnailProps = Exclude<DNACustomDeckProps, 'showProcessing'>
type DNACustomDeckThumbnailComponent = React.FC<DNACustomDeckProps> & {
  Hover: typeof HoverPreview
}

// [TODO-REFACTOR] - We should have one "connected" thumbnail -- consolidate with DNADocumentThumbnail
const DNACustomDeckThumbnail: DNACustomDeckThumbnailComponent = (props) => {
  const {
    unavailableContent,
    customDeckORM,
    width,
    height,
    onPress,
  } = props

  const thumbnailStacks =
    (<React.Fragment>
      <Iffy is={!unavailableContent}>
        <Stack anchor="center">
          <Stack.Layer>
            <DNAThumbnail
              s3URL={customDeckORM.meta.assets.thumbnailKey}
              height={height}
              width={width}
              useLoadingIndicator
            />
          </Stack.Layer>
        </Stack>
      </Iffy>
      { /* NO CONTENT AVAILABLE THUMBNAIL */}
      <Iffy is={unavailableContent}>
        <Stack anchor="center">
          <Stack.Layer>
            <DNAThumbnail
              s3URL={customDeckORM.meta.assets.thumbnailKey}
              height={height}
              width={width}
              useLoadingIndicator
            />
          </Stack.Layer>
          <Stack.Layer>
            <DNABox
              alignY="center"
              alignX="center"
              style={{ backgroundColor: colors['color-gray-transparent-40'], minHeight: height, width }}
            >
              <ThumbnailOverlayIcon variant="cloud" size={width > 200 ? 'xl' : 'md'}/>
            </DNABox>
          </Stack.Layer>
        </Stack>
      </Iffy>
    </React.Fragment>)

  /** Allow for optional custom interaction behavior */
  if (onPress) {
    return (
      <Pressable onPress={onPress}>
        {thumbnailStacks}
      </Pressable>
    )
  }

  /** Otherwise, return non-interactive version allowing for any parent container interactions to take effect */
  return (
    <>
      { thumbnailStacks }
    </>
  )
}

const HoverPreview: React.FC<React.PropsWithChildren<
  DNACustomDeckProps &
  ThumbnailHoverProps
>> = (props) => {
  const { popover, previewSize = 'lg', ...restProps } = props
  const { deviceMode } = useAppSettings()

  const previewOffset = useHoverContentOffset(previewSize, restProps.width)

  if (deviceMode === 'tablet')
    return (
      <DNACustomDeckThumbnail {...restProps} />
    )
  
  return (
    <DNABox alignX='start'>
      <Popover
        {...(popover ?? DEFAULT_POPOVER_PROPS)}
        offset={previewOffset}
        type='preview'
        lazyMount
      >
        <Popover.Anchor>
          <DNACustomDeckThumbnail {...restProps} />
        </Popover.Anchor>
        <Popover.Content>
          <DNACustomDeckThumbnail
            {...restProps}
            width={HOVER_PREVIEW_SIZES[previewSize].width}
            height={HOVER_PREVIEW_SIZES[previewSize].height}
          />
        </Popover.Content>
      </Popover>
    </DNABox>
  )
}

DNACustomDeckThumbnail.Hover = HoverPreview

export default DNACustomDeckThumbnail
